import { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import UserProfileContent from './UserProfileContent'

function UserProfileModal({ open, setOpen }) {
  const dropdownRef = useRef(null)

  useEffect(() => {
    if (!open) return

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [open, setOpen])

  useEffect(() => {
    if (!open) return

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setOpen(false)
      }
    }

    document.addEventListener('keydown', handleEscape)
    return () => document.removeEventListener('keydown', handleEscape)
  }, [open, setOpen])

  if (!open) return null

  return (
    <div
      ref={dropdownRef}
      className="absolute top-full right-0 mt-1 w-[420px] bg-white border border-gray-200 z-50"
      style={{
        borderRadius: '4px',
        boxShadow: '0 0 8px 0 rgba(0,0,0,0.25), 0 8px 4px 0 rgba(0,0,0,0.05)',
      }}
    >
      <UserProfileContent onClose={() => setOpen(false)} />
    </div>
  )
}

UserProfileModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
}

export default UserProfileModal
